import { combineReducers } from "redux";
import applications from "./applications";
import active_application from "./active_application";
import { keycloakReducer as keycloak } from "@authzsvc/keycloak-js-react";
import requests from "./requests";
import breadcrumbs from "./breadcrumbs";
import active_tab from "./active_tab";
import providers from "./providers";
import groups from "./groups";
import sidebar from "./sidebar";
import levelsOfAssurance from "./levelsOfAssurance";
import active_role from "./active_role";
import selectedRegistration from "./selectedRegistration.js";
import tokenExchange from "./tokenExchange";
import applicationRequests from "./applicationRequests";
import applicationsV2 from "./applicationsV2";

const rootReducer = combineReducers({
  keycloak,
  requests,
  applicationRequests,
  applications,
  active_application,
  breadcrumbs,
  active_tab,
  active_role,
  tokenExchange,
  providers,
  selectedRegistration,
  groups,
  sidebar,
  levelsOfAssurance,
  applicationsV2,
});

export default rootReducer;
